import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import i18nextScannerConfig from './i18next-scanner.config';
import { getPersistedLanguage } from './components/LanguageSelector';
import { ENGLISH, FINNISH, NORWEGIAN, SWEDISH } from './constants/LanguageCodes';
import { FINLAND, GREAT_BRITAIN, NORWAY, SWEDEN } from './constants/CountryCodes';
import { mapToLanguageCode } from './utils';

// https://react.i18next.com/guides/quick-start

export const knownLanguages = [
  [ 'fi', 'Suomi' ],
  [ 'sv', 'Svenska' ],
  [ 'en-GB', 'English' ], // Use en-GB to get sane date time formatting
  [ 'no', 'Norsk' ],
];

const resources = {};

for (const [ lang, _ ] of knownLanguages) {
  resources[lang] = { translation: require(`./translations/${lang}.json`) };
}


i18n
  .use(initReactI18next)
  .init({
    resources: resources,
    lng: mapToLanguageCode(getPersistedLanguage().toLocaleLowerCase()),
    fallbackLng: ENGLISH,
    returnEmptyString: false,

    // keySeparator: i18nextScannerConfig.options.keySeparator, //This was removed so nested keys can be used
    nsSeparator: i18nextScannerConfig.options.nsSeparator,
    contextSeparator: i18nextScannerConfig.options.contextSeparator,

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
